import { render, staticRenderFns } from "./nbn-options.vue?vue&type=template&id=99168438&scoped=true"
import script from "./nbn-options.vue?vue&type=script&lang=js"
export * from "./nbn-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99168438",
  null
  
)

export default component.exports